import { ThemeProperties } from '../../core';

export interface FileViewerTheme {
	background: string;
	textColor: string;
}
export const theme = new ThemeProperties('fileViewer');
